import { useEffect } from 'react'
import { useLocation, Outlet } from 'react-router-dom'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import Header from './Header'
import './Layout.css'

const Layout = () => {
  const location = useLocation()
  const { webApp } = useTelegramWebApp()

  // useEffect(() => {
  //   if (webApp) {
  //     // Показываем кнопку "назад" везде, кроме главной страницы
  //     if (location.pathname === '/') {
  //       webApp.BackButton.hide()
  //     } else {
  //       webApp.BackButton.show()
  //     }
  //   }
  // }, [location.pathname, webApp])

  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
